export default __webpack_public_path__ + "static/media/FrostFieldsMap.ba2bb452.jpg";